// eslint-disable-next-line import/no-cycle
import { customersApi, samplesApi, locationsManagementApi } from '@/api';

import {
  LAB_SAMPLE_STATUSES,
  sectorsList,
  sampleDescriptionsList,
  laboratories,
} from '@/config/constants';
import { filterOptions } from '@/config/enumOptions';

const availableStatuses = [
  {
    value: LAB_SAMPLE_STATUSES.ACCEPTED,
    label: 'enums.sampleStatuses.accepted',
  },
  {
    value: LAB_SAMPLE_STATUSES.INPROGRESS,
    label: 'enums.sampleStatuses.inprogress',
  },
  {
    value: LAB_SAMPLE_STATUSES.TOBEVERIFIED,
    label: 'enums.sampleStatuses.toBeVerified',
  },
];

const availableLaboratories = [
  { value: laboratories.CHIM, label: 'enums.laboratories.CHIM' },
  { value: laboratories.MICR, label: 'enums.laboratories.MICR' },
];

const insertAnalysesDataFilters = [
  {
    name: 'sampleId',
    label: 'customerSampleId',
    type: 'number',
    whereOperator: '=',
  },
  {
    name: 'id',
    label: 'sampleId',
    type: 'autocomplete',
    whereOperator: '=',
    placeholder: 'Digita almeno 3 caratteri per cercare...',
    autocompleteSearch: async (queryString, cb) => {
      // Require minimum 3 characters to prevent overly broad searches
      if (!queryString || queryString.trim().length < 3) {
        cb([
          {
            label: 'Digita almeno 3 caratteri per iniziare la ricerca',
            value: null,
            disabled: true,
          },
        ]);
        return;
      }
      const customersResponse = await samplesApi.autocompleteFetch(
        'labSampleCode',
        queryString,
        false
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: c.labSampleCode,
        value: c.id,
      }));
      cb(filteredResults);
    },
    popperClass: 'width-auto',
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'year',
    label: 'year',
    type: 'number',
    min: '20',
    max: '99',
    whereOperator: '=',
  },
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  // {
  //   name: 'customerId',
  //   label: 'customerId',
  //   type: 'text',
  //   whereOperator: '=',
  // },
  {
    name: 'groupingId',
    label: 'grouping',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'acceptedAt',
    label: 'receivedDate',
    type: 'dateDay',
  },
  {
    name: 'quarantineDate',
    label: 'quarantineDate',
    type: 'dateDay',
  },
  {
    name: 'sampleAnalysisStart',
    label: 'sampleAnalysisStart',
    type: 'dateDay',
  },
  {
    name: 'sampleAnalysisEnd',
    label: 'sampleAnalysisEnd',
    type: 'dateDay',
  },
  {
    name: 'productName',
    label: 'productName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sampleDescription',
    label: 'sampleDescription',
    type: 'select',
    filterable: true,
    whereOperator: '=',
    options: filterOptions(sampleDescriptionsList, 'enums.sampleDescriptions'),
  },
  {
    name: 'lot',
    label: 'lot',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sector',
    label: 'sector',
    type: 'select',
    whereOperator: '=',
    options: filterOptions(sectorsList, 'enums.sectors'),
  },
  {
    name: 'laboratory',
    label: 'department',
    type: 'select',
    whereOperator: '=',
    options: availableLaboratories,
  },
  {
    name: 'locationId',
    label: 'locationIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'status',
    label: 'status',
    type: 'select',
    whereOperator: '=',
    options: availableStatuses,
  },
  {
    name: 'progressive',
    label: 'progressive',
    type: 'text',
    whereOperator: 'regexp',
    customizeQueryString: (queryString) => queryString.padStart(5, '0'),
  },
  {
    name: 'stabilityTimepointToken',
    label: 'stabilityToken',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'isStability',
    label: 'stabilityFilter',
    type: 'stability',
    whereOperator: '=',
  },
];

export default insertAnalysesDataFilters;
